export default __webpack_public_path__ + "static/media/BeforePhoto9.7428b088.jpg";